import React, { useState } from "react";
import styled from "styled-components";
import { Modal, Button, Typography, TextField } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ebebeb;
  width: 90%;
  height: 350px;
  padding: 5px 0;
  &:focus {
    outline: none;
  }
  .header {
    margin: 0 10px;
    text-align: right;
  }
  .exchange_content {
    height: 100%;
    margin: 20px;
    display: flex;
    gap: 2rem;
    flex-direction: column;
    .exchange_content_item {
      width: 100%;
      margin: 5px 0;
      font-size: 1.5rem;
      font-weight: normal;
      border-radius: 0px;
      .MuiOutlinedInput-notchedOutline {
        border: 0px;
      }
    }

    .error_msg {
      color: #7b7c7e;
      font-size: 1rem;
    }
  }
  .MuiOutlinedInput-root {
    background-color: #fff;
    border-radius: 0;
    width: 100%;
  }
`;

const ExchangeModal = ({
  couponId,
  isExchanged,
  canExcange,
  submitPostCoupon,
  invalidRedeemCode,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [redeemCode, setRedeemCode] = useState("");
  const openModal = () => {
    setIsOpen(true);
  };
  const exchangeCoupon = (e) => {
    e.preventDefault();
    submitPostCoupon({ redeemCode, couponId });
  };
  return (
    <>
      <Button
        disabled={isExchanged || !canExcange}
        variant={isExchanged ? "contained" : "outlined"}
        className="coupon_btn"
        onClick={openModal}
      >
        {canExcange ? (isExchanged ? "已兌換" : "票券兌換") : "未於兌換期間"}
      </Button>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Wrapper>
          <div className="header">
            <CloseOutlinedIcon
              onClick={() => setIsOpen(false)}
              className="close_icon"
              color="primary"
            />
          </div>
          <div className="exchange_content">
            <Typography className="exchange_content_item" align="center">
              請交由服務人員
              <br />
              輸入兌換碼​
            </Typography>
            <div>
              <TextField
                className="exchange_content_item"
                onChange={(e) => setRedeemCode(e.target.value)}
              />
              {invalidRedeemCode && (
                <Typography className="error_msg" align="left">
                  *兌換碼輸入錯誤
                </Typography>
              )}
            </div>
            <Button
              variant="outlined"
              className="coupon_btn exchange_content_item"
              onClick={exchangeCoupon}
            >
              確認兌換
            </Button>
          </div>
        </Wrapper>
      </Modal>
    </>
  );
};

export default ExchangeModal;
